import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {Application, ApplicationsQueryResponse} from './_models'
import { IWebPhase0Model } from './_webmodels'

const API_URL = process.env.REACT_APP_API_URL

const getApplications = (): Promise<ApplicationsQueryResponse> => {        
    return axios.get(`${API_URL}/ApplicationServlet`)
    .then((res) => {
        // conform output to { data, payload } object.
        return {data : res.data , payload : {}};
    })       
}

const getAllApplications = (): Promise<ApplicationsQueryResponse> => {        
    return axios.get(`${API_URL}/AllApplicationServlet`)
    .then((res) => {
        // conform output to { data, payload } object.
        return {data : res.data , payload : {}};
    })       
}

const getApplicationById = (id : number): Promise<Application> => {
    // get application record
    return axios.post(`${API_URL}/ApplicationServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
    .then((d: AxiosResponse<Application>) => d.data)        
}


const deleteApplication = (applicationId: ID): Promise<void> => {
    return axios.delete(`${API_URL}/ApplicationServlet?id=${applicationId}`).then(() => {})
}


const getCertificateDates = (applicationId : number, skip: boolean = false) => {
    // get suggested dates for certificate
    return axios.post(`${API_URL}/GetDateServlet`,  { applicationId, skip } )        
}


const reserveCoCNumber = (id : number) => {
    // get suggested dates for certificate
    return axios.post(`${API_URL}/CertificateReserveServlet`,  id, { headers: { "Content-Type": "text/plain" }} )        
}


const claimApplication = (applicationid: number, id: number) => {
    return axios.post(`${API_URL}/ReassignApplicationServlet`, { applicationid, id })
}

const requestApplicationTerminate = (data : any) => {
    return axios.post(`${API_URL}/TerminateApplicationServlet`, data)           
}



function saveDraftApplication(data : IWebPhase0Model) {

    // return file ids
    if (data.isoFileAttachments) {
        Object.assign(data, {
            isoAttachment : data.isoFileAttachments.map( o => (o.id)),            
        } )    
        delete data.isoFileAttachments;
    }

    if (data.productFileAttachments) {
        Object.assign(data, {        
            productAttachment : data.productFileAttachments.map( o => (o.id)),
        })
        delete data.productFileAttachments;
    }

    return axios.post(`${API_URL}/DraftApplicationServlet`, data)
}



// Program Manager Rejected (A) - Admin Response
function submitCAMSPhase_7_2(data : any) {
    return axios.post(`${API_URL}/Phase_7_2Servlet`, data);
}

// Program Manager Approval - Issue (A) - Applicant Response to Admin
function submitCAMSPhase_7_3(data : any) {
    return axios.post(`${API_URL}/Phase_7_3Servlet`, data);
}

// Program Manager Rejected (I) - Inspector Response
function submitCAMSPhase_7_4(data : any) {
    return axios.post(`${API_URL}/Phase_7_4Servlet`, data);
}

// Program Manager Approval - Issue (I) - Applicant Response to Inspector
function submitCAMSPhase_7_5(data : any) {
    return axios.post(`${API_URL}/Phase_7_5Servlet`, data);
}

function editApplicationComment(data : {applicationid: number, comment: string}) {
    return axios.post(`${API_URL}/EditApplicationCommentServlet`, data);
}


function createAwardLetter(id: number) {
  return axios.post(`${API_URL}/AwardLetterCreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}


function generateAwardLetter(data : any) {
  return axios.post(`${API_URL}/AwardLetterGenerateServlet`, data, { responseType: 'blob' });
}



function createSuspendLetter(id: number) {
  return axios.post(`${API_URL}/SuspendLetterCreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}

function generateSuspendLetter(data : any) {
  return axios.post(`${API_URL}/SuspendLetterGenerateServlet`, data, { responseType: 'blob' });
}


function createWithdrawLetter(id: number) {
  return axios.post(`${API_URL}/WithdrawLetterCreateServlet`,  id, { headers: { "Content-Type": "text/plain" }} );
}

function generateWithdrawLetter(data : any) {
  return axios.post(`${API_URL}/WithdrawLetterGenerateServlet`, data, { responseType: 'blob' });
}

export {
    getApplications, getAllApplications, deleteApplication, getApplicationById, 
    claimApplication, saveDraftApplication, requestApplicationTerminate,
    getCertificateDates, reserveCoCNumber, 
    submitCAMSPhase_7_2,
    submitCAMSPhase_7_3,
    submitCAMSPhase_7_4,
    submitCAMSPhase_7_5,
    editApplicationComment,

    createAwardLetter, generateAwardLetter,
    createSuspendLetter, generateSuspendLetter,
    createWithdrawLetter, generateWithdrawLetter,
}
